<template>
  <div>
     <div class="container-fluid">
         <div class="row">
         <div class="col-md-12">
         <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''"></div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
         </div>
         <div class="col-12">
              <div class="content-pages">
                 <h2 class="page-title">Store locator</h2>
                 <div class="row">
                  <div class="col-md-3 col-12">
                  <div>
                      <input class="form-control mb-sm-2" v-model="search" type="text" placeholder="Search">
                  </div>
                  <div class="sidebar">
                      <div v-for="(store, index) in filteredList" :key="store.infoText.address" class="store-locator-result">
                        <div class="store-info" @click="toggleInfoWindow(store,index)">
                          <h4>{{store.infoText.name}}</h4>
                          <p>{{store.infoText.address}}</p>
                          <p>{{store.infoText.city}}, {{store.infoText.state}} {{store.infoText.zip}}</p>
                          <p v-if="store.infoText.phone">Tel.: {{store.infoText.phone}}</p>
                          <!-- <p>Fax: {{store.infoText.fax}}</p> -->
                          <p v-if="store.infoText.email">Email: {{store.infoText.email}}</p>
                        </div>
                        <div class="store-directions">
                          <a :href="`https://maps.google.com/maps?daddr=${store.infoText.address} ${store.infoText.city}, ${store.infoText.state} ${store.infoText.zip}`" target="blank"><i class="fa fa-map-marker"></i> Get Directions</a>
                        </div>
                    </div>
                    <div class="store_error"  v-if="filteredList.length === 0">No results found</div>
                  </div>
                  </div>
             
                  <div class="col-md-9 col-12">
                      <GmapMap
            :center="center"
            :zoom="zoom"
            map-type-id="terrain"
            ref="map"
          >
          <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
              <div class="info-window">
                <p><b>{{infoContent.name}}</b></p>
                <p>{{infoContent.address}}</p>
                <p>{{infoContent.city}}, {{infoContent.state}} {{infoContent.zip}}</p>
                <p>Tel.: {{infoContent.phone}}</p>
                <p>Fax: {{infoContent.fax}}</p>
                <p>Email: {{infoContent.email}}</p>
                <a :href="`https://maps.google.com/maps?daddr=${infoContent.address} ${infoContent.city}, ${infoContent.state} ${infoContent.zip}`" target="blank"><i class="fa fa-map-marker"></i> Get Directions</a>
              </div>
            </gmap-info-window>
            <GmapMarker
              :key="index"
              v-for="(m, index) in filteredList"
              :position="m.position"
              :clickable="true"
              @click="toggleInfoWindow(m,index)"
            />
          </GmapMap>
                  </div>
             </div>
              </div>
         </div>
         </div>
     </div>
  </div>
</template>

<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyABzA9XnM_g51esLxbDQdAdZAjtz3wjIMc',
    libraries: 'places,geometry'
  }
});
import axios from 'axios';
export default {
  name: 'GoogleMap',
  metaInfo () {
      return {
          title:this.meta_title,
          meta: [
          {
              name: 'description',
              content: this.meta_description
          },
          {
              property: 'keywords',
              content: this.meta_keyword
          }
          ]
      }
  },
  data () {
    return {
      meta_title:'',
      meta_description:'',
      meta_keyword:'',
      search:'',
      serviceCenters:[],
      center: {lat: 23.232681, lng: 77.4285496},
      zoom: 4,
      infoContent: {},
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      place: null,
      radius: 100
    }
  },
  methods: {
     getStore(){
           axios.get(this.$root.api_url+`/pim/pimresponse.php`, {
            params: {
                service:'storelocator',
                store:'all',
            }
          })
          .then(response => {
            this.serviceCenters = response.data.result;
            this.serviceCenters.map(element => {
              // console.log(element);
              if(element.lat!=''){
              this.markers.push(
                {
                  position: {
                    lat: Number(element.location_latitude),
                    lng: Number(element.location_longitude)
                  },
                  infoText: {
                    search:element.address +" "+ element.city +" "+ element.state +" "+ element.postcode,
                    name: element.name,
                    address: element.address,
                    city: element.city,
                    state: element.state,
                    zip: element.postcode,
                    phone: element.phone,
                    fax: element.fax,
                    email: element.email,
                  }
                }
              )
              }
          });
          })
          .catch(error =>
          {
              if(error.message === "Network Error"){
                this.$root.error_message = error.message;
              }
              window.scrollTo(0,0);
          })
        },
        toggleInfoWindow (marker, idx) {
          this.infoWindowPos = marker.position
          this.infoContent = marker.infoText
          
          if (this.currentMidx === idx) {
            this.infoWinOpen = !this.infoWinOpen
            
          } else {
            this.infoWinOpen = true
            this.currentMidx = idx
            this.zoom = 18
            this.center.lat = this.infoWindowPos.lat
            this.center.lng = this.infoWindowPos.lng
          }
        },
  },
  mounted() {
     this.getStore();
  },
  computed: {
    filteredList() {
      return this.markers.filter(post => {
        return post.infoText.search.toLowerCase().includes(this.search.toLowerCase());
      })
      
    },
    
  },
  created () {
    window.scrollTo(0, 0);
        this.$root.breadcrumb = 'Store Locator';
        if(this.$root.store === 1){
            this.meta_title = 'Store Locator';
            this.meta_description = 'Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.';
            this.meta_keyword = 'Online Shopping for Women,  W for Woman';
        }
        else
        {
           this. meta_title = 'Store Locator';
           this.meta_description = 'Shop a wide range of women online fashionable clothes that suits every occasion - Top wear, Bottom wear, Suit Sets &amp; Dupatta. Free Shipping. COD. 15-Day Returns.';
           this.meta_keyword = 'online shopping for women, fashion women clothing, buy womens clothing online, shop women clothing';
        }
    }
}
</script>
<style scoped>
.info-window p 
{
  margin-bottom: 5px;
  font-size:12px;
}
.vue-map-container {
  display: inline-block;
  width: 100%;
  height: 450px;
}
.store_error
{
  color:red;
}
</style>
